import { Navigate, Route, Routes } from "react-router-dom";

import SearchParams from "simplydo/core/searchParams";
import { styled } from "simplydo/react/styled";

import { useAppSelector } from "store";

import AppStyledDashboard from "components/AppStyledDashboard";
// import DownloadAppBanner from "components/home/DownloadAppBanner";

import Enrol from "./Enrol";
import ForgottenPassword from "./ForgottenPassword";
import Login from "./Login";
import RegisterFlow from "./RegisterFlow";
import ResetPassword from "./ResetPassword";

const StyledEntry = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Entry = () => {
  const user = useAppSelector((state) => state.user);

  if (user) {
    const params = new SearchParams(window.location.search);
    const then = params.get("then") ?? "/";
    const code = params.get("code");
    if (then && (!code || (code && user?.ownerOrganisation?.code === code))) {
      return <Navigate to={then} replace />;
    }
  }

  return (
    <StyledEntry>
      {/* <DownloadAppBanner /> */}
      <Routes>
        <Route
          path="password/forgotten"
          element={
            <AppStyledDashboard
              excludeWelcomeText
              padded="very"
              content={<ForgottenPassword />}
            />
          }
        />
        <Route
          path="password/reset"
          element={
            <AppStyledDashboard
              excludeWelcomeText
              padded="very"
              content={<ResetPassword />}
            />
          }
        />
        <Route
          path="enrol"
          element={
            <AppStyledDashboard
              excludeWelcomeText
              padded="very"
              scrolling={false}
              content={<Enrol />}
            />
          }
        />
        <Route
          path="register"
          element={
            <AppStyledDashboard
              excludeWelcomeText
              scrolling={false}
              padded="very"
              content={<RegisterFlow />}
            />
          }
        />
        <Route
          path="*"
          element={
            <AppStyledDashboard
              backgroundColor="#14435B"
              excludeWelcomeText
              scrolling={false}
              padded="very"
              content={<Login />}
            />
          }
        />
      </Routes>
    </StyledEntry>
  );
};

export default Entry;
